import React from "react";
import { Helmet } from "react-helmet-async";

interface EventSchemaProps {
  name: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  location?: string;
  organizerName?: string;
  url?: string;
  image?: string;
}

const EventSchema: React.FC<EventSchemaProps> = ({
  name,
  description,
  startDate,
  endDate,
  location,
  organizerName,
  url,
  image,
}) => {
  const schema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Event",
    name,
    ...(description && { description }),
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
    ...(location && {
      location: {
        "@type": "Place",
        name: location,
      },
    }),
    ...(organizerName && {
      organizer: {
        "@type": "Organization",
        name: organizerName,
      },
    }),
    ...(url && { url }),
    ...(image && { image }),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default EventSchema;
